import { Component, OnInit } from '@angular/core';

import { HubSpotScriptService } from '@app/hub-spot-script.service';

@Component({
  selector: 'sociuu-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  providers: [HubSpotScriptService],
})
export class AdminComponent implements OnInit {
  constructor(private hubSpotScriptService: HubSpotScriptService) {
  }

  public ngOnInit(): void {
    this.loadHubSpotScript();
  }

  private loadHubSpotScript(): void {
    this.hubSpotScriptService.loadHubSpotScript();
  }
}
